<template>
    <div v-view.once="handler">
         <div class="flex justify-between items-center mb-4">
              <head-line :level="2" size="1" :bold="true">{{ headline }}</head-line>
             <div class="inline-flex">
              <!-- <router-link class="bg-white  text-gray-800 font-semibold py-2 px-4 border-2 border-gray-400 rounded"
              :class="[{'md:mr-6': !isRtl},{'md:ml-6': isRtl}]"
              to="/articles"

              >
                  {{ $t('btn.viewAll') }}
              </router-link > -->

              <button class="prev bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 hidden md:block"
              :class="[{'rounded-l': !isRtl},{'rounded-r': isRtl}]" @click="prev">
                <svg v-if="!isRtl" class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M14.7 15.3C14.8444 15.4926 14.9146 15.7308 14.8975 15.9709C14.8804 16.211 14.7773 16.4369 14.6071 16.6071C14.4369 16.7773 14.211 16.8804 13.9709 16.8975C13.7308 16.9146 13.4926 16.8444 13.3 16.7L9.30002 12.7C9.11679 12.5131 9.01416 12.2618 9.01416 12C9.01416 11.7383 9.11679 11.4869 9.30002 11.3L13.3 7.30001C13.4926 7.15558 13.7308 7.08546 13.9709 7.10252C14.211 7.11959 14.4369 7.22269 14.6071 7.3929C14.7773 7.56311 14.8804 7.78901 14.8975 8.02912C14.9146 8.26923 14.8444 8.50744 14.7 8.70001L11.42 12L14.72 15.3H14.7Z"/>
                </svg>
                 <svg v-else class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/>
                 </svg>
              </button>
              <button class="next bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4  hidden md:block"
              :class="[{'rounded-r': !isRtl},{'rounded-l': isRtl}]" @click="next">
               <svg v-if="!isRtl" class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/>
                 </svg>
                 <svg v-else class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M14.7 15.3C14.8444 15.4926 14.9146 15.7308 14.8975 15.9709C14.8804 16.211 14.7773 16.4369 14.6071 16.6071C14.4369 16.7773 14.211 16.8804 13.9709 16.8975C13.7308 16.9146 13.4926 16.8444 13.3 16.7L9.30002 12.7C9.11679 12.5131 9.01416 12.2618 9.01416 12C9.01416 11.7383 9.11679 11.4869 9.30002 11.3L13.3 7.30001C13.4926 7.15558 13.7308 7.08546 13.9709 7.10252C14.211 7.11959 14.4369 7.22269 14.6071 7.3929C14.7773 7.56311 14.8804 7.78901 14.8975 8.02912C14.9146 8.26923 14.8444 8.50744 14.7 8.70001L11.42 12L14.72 15.3H14.7Z"/>
                </svg>
              </button>
            </div>
         </div>
        <div  v-if="!loaded && loading" class="relative -mx-1 md:mx-0">
          <div class="flex flex-no-wrap justify-between overflow-hidden w-full">
            <article-placeholder></article-placeholder>
            <article-placeholder></article-placeholder>
            <article-placeholder></article-placeholder>
            <article-placeholder></article-placeholder>
            <article-placeholder></article-placeholder>
          </div>
        </div>
        <div class="relative -mx-1 md:mx-0">
           <flickity v-if="loaded" ref="flickity" :options="flickityOptions">
                <card
                v-for="article in articles"
                v-bind:key="article.Id"
                style="width: 290px"
                class="bg-white mx-4"
                :title="article.Title"
                :description="article.Summary"
                :img="article.ThumbnailUrl"
                :link="article.Id"
                >

                </card>
           </flickity>
            <div class="absolute w-4 md:w-12 h-full top-0 right-0 z-50 right"></div>
            <div class="absolute w-4 md:w-12 h-full top-0 left-0 z-50 left"></div>
        </div>
    </div>

</template>

<script>
import Flickity from 'vue-flickity';
import HeadLine from '@/components/theme/HeadLine';
import {mapGetters} from 'vuex';
import ArticlePlaceholder from '@/components/layout/home/ArticlePlaceholder';
import Card from '@/components/Card';

export default {
   name: "ArticleCarousel",
   props: ['headline'],
   components: {Flickity, HeadLine,ArticlePlaceholder, Card},
   data() {
    return {
       flickityOptions: {
        initialIndex: 0,
        freeScroll: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        groupCells: true
      }
    }
   },
   updated() {
    if(this.$refs.flickity) this.$refs.flickity.resize();
   },
   computed: {
    ...mapGetters({
        isRtl: ['locale/IS_RTL'],
        loaded: ['article/LOADED'],
        loading: ['article/LOADING'],
        articles: ['article/ARTICLES'],
    })
   },
   methods: {
    prev() {
        this.$refs.flickity.previous();
    },
    next() {
        this.$refs.flickity.next();
    },
    async handler() {
       if(this.loaded) return;
       await this.$store.dispatch('article/FETCH_ARTICLES');
       this.$refs.flickity.resize()
       this.$refs.flickity.reloadCells()
    }

   },
   watch: {
     "$i18n.locale": function () {
        this.$store.dispatch('article/SET_LOADED', false);
        this.handler();
     }
   }
}
</script>
<style>
.flickity-enabled {
  position: relative;
}
.flickity-enabled:focus { outline: none;
}
.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}
.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
}

/* draggable */
.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}
.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}

/* ---- flickity-button ---- */
.flickity-button {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.75);
  border: none;
  color: #333;
}
.flickity-button:hover {
  background: white;
  cursor: pointer;
}
.flickity-button:focus {
  outline: none;
  box-shadow: 0 0 0 5px #19F;
}
.flickity-button:active {
  opacity: 0.6;
}
.flickity-button:disabled {
  opacity: 0.3;
  cursor: auto;
  /* prevent disabled button from capturing pointer up event. #716 */
  pointer-events: none;
}
.flickity-button-icon {
  fill: currentColor;
}

/* ---- previous/next buttons ---- */
.flickity-prev-next-button {
  top: 50%;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  /* vertically center */
  transform: translateY(-50%);
}
.flickity-prev-next-button.previous { left: 10px;
}
.flickity-prev-next-button.next { right: 10px;
}

/* right to left */
.flickity-rtl .flickity-prev-next-button.previous {
  left: auto;
  right: 10px;
}
.flickity-rtl .flickity-prev-next-button.next {
  right: auto;
  left: 10px;
}
.flickity-prev-next-button .flickity-button-icon {
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
}

/* ---- page dots ---- */
.flickity-page-dots {
  position: absolute;
  width: 100%;
  bottom: -25px;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  line-height: 1;
}
.flickity-rtl .flickity-page-dots { direction: rtl;
}
.flickity-page-dots .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 8px;
  background: #333;
  border-radius: 50%;
  opacity: 0.25;
  cursor: pointer;
}
.flickity-page-dots .dot.is-selected {
  opacity: 1;
}

   .left {
        background: -webkit-gradient(linear, right top, left top, from(transparent), to(#ffffff));
        background: -o-linear-gradient(right, transparent 0%, #ffffff 100%);
        background: linear-gradient(to left, transparent 0%, #ffffff 100%);
    }
    .right {
        background: -webkit-gradient(linear, left top, right top, from(transparent), to(#ffffff));
        background: -o-linear-gradient(left, transparent 0%, #ffffff 100%);
        background: linear-gradient(to right, transparent 0%, #ffffff 100%);
    }
</style>
